
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import ConfirmPaymentItem from "./components/confirm-payment.vue";
import RegisterInvoice from "./components/register-invoice.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit, partsPropComb } from "@common/src/utils/tools";

const service = namespace("service");
const setting = namespace("setting");
const purchase = namespace("purchase");
const app = namespace("app");
const inventory = namespace("inventory");

@Component({
  components: {
    StepList,
    ConfirmPaymentItem,
    RegisterInvoice
  }
})
export default class PurchaseView extends Vue {
  @purchase.Action getPurchaseDetail;
  @purchase.Action purchaseCancel;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  @inventory.Action generateBatchNumber;
  @purchase.Action purchaseInbound;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @setting.State fifoStatus;
  @setting.State inboundProductTaxRateMode;
  @setting.State productionBatchNoStatus;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  partsPropComb = partsPropComb;
  inboundDialogVisible = false;
  inboundData = [];
  get breadData() {
    return [
      { name: t("purchase.purchase-manage"), path: "/purchase/index" },
      { name: t("v210906.view-purchase-order") }
    ];
  }
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        returnAdditionalFees: this.detailData.returnAdditionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  get cancelData() {
    if (this.detailData.cancelBean) {
      return [this.detailData.cancelBean];
    }
    return [
      {
        receiptNo: this.detailData.receiptNo,
        receiptAmount: this.detailData.receiptAmount,
        cancelDate: this.detailData.cancelDate,
        cancelRemark: this.detailData.cancelRemark,
        cancelOperatorName: this.detailData.cancelOperatorName
      }
    ];
  }
  get setTaxInclude() {
    return this.inboundProductTaxRateMode === "ALL_TAX_INCLUDED";
  }
  paymentData: any = {};
  payWayList: any = [];
  async created() {
    await this.init();
    if (
      this.$route.query.inbound === "true" &&
      (this.detailData.purchaseStatus === "2" || this.detailData.purchaseStatus === "3")
    ) {
      this.showInboundDialog();
    }
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  cancelForm: any = {
    remark: "",
    paidAmount: "",
    paidMethod: ""
  };
  cancelFormRules: any = {
    supplierName: [{ required: true, message: t("setting.enter-supplier-name"), trigger: "blur" }]
  };
  showCancel: boolean = false;
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.showCancel = true;
    }
    if (command === "return") {
      let { href } = this.$router.resolve({
        path: `/purchase/purchase-refund-add?order=${this.detailData.purchaseNo}`
      });
      window.open(href, "_blank");
    }
  }
  handleCancel() {
    this.purchaseCancel({
      purchaseNo: this.orderId,
      ...this.cancelForm
    }).then(() => {
      this.showCancel = false;
      this.$message.success(t("finance.cancel-success"));
      this.init();
    });
  }
  handlePaymentConfirmClick(data) {
    console.log(data);
    let params = {
      orderList:
        data.settleType === 1
          ? [{ orderNo: this.orderId }]
          : data.selectedRows.map(item => {
              item.orderNo = item.purchaseNo;
              return item;
            }),
      paidList: [
        {
          paidAmount: data.settleType === 1 ? data.paidAmount : 0,
          paidMethod: data.paidMethod
        }
      ],
      remark: ""
    };
    this.setPaymentBtnLoading(true);
    this.createPurchasePayment(params)
      .then(() => {
        this.$message.success(t("base.payment-success"));
        this.showComfirmPayment = false;
        this.init();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(() => {
        this.$message.success(t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.init();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  get orderId() {
    return this.$route.params.id;
  }
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  emptyToLine = emptyToLine;
  detailData: any = { purchaseStatus: "2", photoList: [] };
  partsHasZero: boolean = false;
  handleComplete() {
    if (
      this.detailData.detailList.some(parts => {
        return Number(parts.costPrice) === 0;
      })
    ) {
      {
        this.partsHasZero = true;
      }
    }
  }
  handleComfirmPaymentShow() {
    this.showComfirmPayment = true;
  }
  handleRegisterInvoice() {
    this.showRegisterInvoice = true;
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  async init() {
    const data = await this.getPurchaseDetail({
      purchaseNo: this.orderId
    });
    this.detailData = data.data;
    let purchaseReturnList = this.detailData.purchaseReturnList;
    this.detailData.purchaseReturnFirst =
      purchaseReturnList && purchaseReturnList.length ? purchaseReturnList[0].returnPurchaseNo : "";
    this.detailData.purchaseReturnMore =
      purchaseReturnList && purchaseReturnList.length > 1 ? purchaseReturnList.splice(1) : [];
    if (this.detailData.settlementStatus === "1") {
      this.cancelForm.paidAmount = this.detailData.purchaseAmount ? Number(this.detailData.purchaseAmount) : 0;
    }
  }
  handleWarehouseChange(row) {
    let selected = row.warehouseList.find(item => row.warehouseCode === item.warehouseCode);
    row.shelfList = selected && selected.shelfList;
    const defaultShelf = row.shelfList.find(item => item.defaultShelf === 1);
    row.shelfCode = defaultShelf.shelfCode;
  }
  async showInboundDialog() {
    let inboundBatchNo = "";
    if (this.fifoStatus === "1") {
      const data = await this.generateBatchNumber();
      inboundBatchNo = data.data;
    }
    const list = this.detailData.detailList.map(item => {
      return {
        ...item,
        qty: item.waitInboundQuantity,
        inboundBatchNo,
        productionBatchNo: "",
        warehouseList: [],
        shelfList: [],
        canInbound: item.waitInboundQuantity > 0,
        taxIncluded: this.fifoStatus === "1" ? "1" : null
      };
    });
    list.forEach(async item => {
      if (item.canInbound) {
        this.queryPartsQtyByWarehouseTree({
          partsCode: item.partsCode
        }).then(data => {
          const warehouseList = this.$safeValue(data, "data.warehouseList", []);
          const defaultWarehouse = warehouseList.find(item => item.defaultWarehouse === 1);
          item.warehouseList = warehouseList;
          item.warehouseCode = defaultWarehouse.warehouseCode;
          this.handleWarehouseChange(item);
        });
      }
    });
    this.inboundData = list;
    this.inboundDialogVisible = true;
  }
  handleConfirmInbound() {
    if (this.inboundData.some(i => i.qty > i.waitInboundQuantity)) {
      this.$message.error(t("v216_g.inbound_quantity_max_tip"));
      return;
    }
    this.btnStartLoading();
    const batchItemList = this.inboundData.filter(i => i.canInbound);
    this.purchaseInbound({
      purchaseNo: this.detailData.purchaseNo,
      batchItemList
    })
      .then(() => {
        this.inboundDialogVisible = false;
        this.$message.success(t("warehouse.inbound-success") as string);
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
